import { gql } from '@apollo/client'
import { AI_INSIGHT } from '../fragments/AiInsight'

export const GET_AI_INSIGHTS = gql`
  query GetAiInsights($input: DXOExecutionForUserInput!) {
    aiInsights(input: $input) {
      results {
        ...AiInsight
      }
      count
    }
  }
  ${AI_INSIGHT}
`
